import { render, staticRenderFns } from "./RadioButton.vue?vue&type=template&id=1407dc76&scoped=true&lang=pug&"
import script from "./RadioButton.vue?vue&type=script&lang=ts&"
export * from "./RadioButton.vue?vue&type=script&lang=ts&"
import style0 from "./RadioButton.vue?vue&type=style&index=0&id=1407dc76&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1407dc76",
  null
  
)

export default component.exports